export default "__VITE_ASSET__104961a0__"